"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var Layout_1 = __importDefault(require("../Layout"));

var ChatIcon_1 = __importDefault(require("../ChatIcon"));

var html_react_parser_1 = __importDefault(require("html-react-parser"));

var classnames_1 = require("./classnames");

var utils_1 = require("../../utils/utils");

var encodedText = function encodedText(str) {
  var textArea = document.createElement("textarea");
  textArea.innerHTML = str;
  return textArea.value;
};

var CardChoice = function CardChoice(props) {
  var isChatIconVisible = props.isChatIconVisible,
      isUser = props.isUser,
      icon = props.icon,
      primaryColor = props.primaryColor,
      label = props.label,
      fontFamily = props.fontFamily,
      shouldShowActions = props.shouldShowActions,
      choices = props.choices,
      handleOptionSelect = props.handleOptionSelect,
      backgroundColor = props.backgroundColor,
      color = props.color;
  return React.createElement(Layout_1.default, {
    isUser: isUser
  }, isChatIconVisible && React.createElement(ChatIcon_1.default, {
    isUser: isUser,
    icon: icon
  }), React.createElement("div", {
    className: classnames_1.container(primaryColor, backgroundColor)
  }, React.createElement("div", {
    className: classnames_1.cardTitle(fontFamily, color)
  }, label), shouldShowActions ? React.createElement("ul", {
    className: classnames_1.cardList
  }, choices.map(function (choice) {
    var decodedLabel = utils_1.decodeEntities(choice.label);
    var decodedSubtext = utils_1.decodeEntities(choice.subText);
    return React.createElement("li", {
      className: classnames_1.cardOption(backgroundColor),
      key: choice.id,
      onClick: function onClick() {
        return handleOptionSelect(choice.label, choice.subText);
      }
    }, React.createElement("span", {
      className: "option"
    }, React.createElement("span", {
      className: classnames_1.cardOptionLabel,
      title: encodedText(choice.label)
    }, React.createElement("div", {
      className: classnames_1.optionLabel(fontFamily, color)
    }, html_react_parser_1.default(decodedLabel))), React.createElement("span", {
      className: classnames_1.cardOptionValue(color)
    }, html_react_parser_1.default(decodedSubtext))));
  })) : null));
};

exports.default = CardChoice;